/**
 * CartAnalyzePresenter
 * --
 */
import React, { useRef, useState, useEffect } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  ModalLayout,
  // Statistic,
} from 'components';
import {
  Button,
  Statistic,
  DatePicker,
  Divider,
  Input,
  Table,
  Radio,
  Spin,
} from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import {
  // XAxis,
  // YAxis,
  // BarChart,
  // Bar,
  // Legend,
  // CartesianGrid,
  // ComposedChart,
  Tooltip,
  Cell,
  PieChart,
  Pie,
} from 'recharts';
import { stringToMoneyFormat } from 'utils';

const data = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

/**----------------------------------------
 * [Component] 총관리자: 장바구니 분석 - 프레젠터
 * ----------------------------------------
 */
const CartAnalyzePresenter = ({
  loading,
  chartData,
  statisticsType,
  setStatisticsType,
  handleGetCartList,
  userListModal,
  setUserListModal,
  userList,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const chartRef = useRef(null);
  const [chartWidth, setChartWidth] = useState(0);

  /* ===== VARIABLE ===== */
  const formItem = [
    {
      label: '기간설정',
      form: [
        {
          input: (
            <>
              <Radio.Group
                size="large"
                defaultValue="month"
                buttonStyle="solid"
                value={statisticsType}
                onChange={(e) => setStatisticsType(e.target.value)}
                style={{ marginRight: 12 }}
                // disabled={
                //   searchFilter.startDate || searchFilter.endDate ? true : false
                // }
              >
                <Radio.Button value="today">오늘</Radio.Button>
                <Radio.Button value="week">1주일(7일)</Radio.Button>
                <Radio.Button value="month">1개월(30일)</Radio.Button>
                <Radio.Button value="3month">3개월(90일)</Radio.Button>
              </Radio.Group>
              {/* <>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder="시작일"
                  // style={{ ...styles.form.date }}
                  // onChange={(d, t) => handleChange('startDate', t)}
                />
                <p style={{ padding: '0px 2px' }}>~</p>
                <DatePicker
                  size="large"
                  format={'YYYY-MM-DD'}
                  placeholder="종료일"
                  // style={{ ...styles.form.date }}
                  // onChange={(d, t) => handleChange('endDate', t)}
                />
              </> */}
            </>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  useEffect(() => {
    const call = (e) => {
      setChartWidth(chartRef.current.clientWidth);
    };
    if (chartRef.current) call();
    window.addEventListener('resize', call);
    return () => {
      window.removeEventListener('resize', call);
    };
  }, [chartRef]);

  /*  */
  const RADIAN = Math.PI / 180;
  /*  */
  const renderCustomLabel = (d) => {
    const { cx, cy, midAngle, innerRadius, outerRadius, percent, name } = d;
    // const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const radius = innerRadius + (outerRadius - innerRadius) * 1.4;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="black"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        // width={20}
      >
        {`${name}: \n${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };
  /* 상품별 데이터 */
  const productChart = chartData?.product
    ? Object.keys(chartData.product).map((item) => ({
        name: chartData.product[item].label,
        value: chartData.product[item].data.length,
        ...chartData.product[item],
      }))
    : [];
  /* 카테고리별 데이터 */
  const categoryChart = chartData?.category
    ? Object.keys(chartData.category).map((item) => ({
        name: chartData.category[item].label,
        value: chartData.category[item].data.length,
      }))
    : [];
  /* 브랜드별 데이터 */
  const shopChart = chartData?.shop
    ? Object.keys(chartData.shop).map((item) => ({
        name: chartData.shop[item].label,
        value: chartData.shop[item].data.length,
      }))
    : [];

  /* ===== RENDER ===== */
  return (
    <>
      <Spin spinning={loading}>
        <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
          <Row>
            <Col x={24}>
              <Title size={4} style={{ marginBottom: 12 }}>
                장바구니 분석
              </Title>

              {/* 검색필터 */}
              <Content
                maxWidth={'99.5%'}
                padding={0}
                // backgroundColor={'none'}
                style={{ marginBottom: 5 }}
              >
                <Row>
                  <Col x={19}>
                    <ExpandableContainer borderRadius={4} padding={20}>
                      {formItem.map((_item, _index) => (
                        <div
                          key={`form_${_index}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '10px 0px',
                          }}
                        >
                          <div
                            style={{
                              width: 120,
                              fontSize: 13,
                              fontWeight: 400,
                            }}
                          >
                            <label>{_item.label}</label>
                          </div>
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            {_item.form.map((_subitem, _subkey) => (
                              <React.Fragment key={`input_${_subkey}`}>
                                {_subitem.input}
                              </React.Fragment>
                            ))}
                          </div>
                        </div>
                      ))}
                    </ExpandableContainer>
                  </Col>
                  {/* === === */}
                  <Col
                    x={5}
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                    }}
                  >
                    <Button
                      size="large"
                      type="primary"
                      onClick={() => handleGetCartList()}
                    >
                      <SearchOutlined /> 검색
                    </Button>
                    &nbsp;
                    <Button
                      size="large"
                      onClick={() => {
                        setStatisticsType('month');
                        handleGetCartList('reset');
                      }}
                    >
                      <ReloadOutlined /> 초기화
                    </Button>
                  </Col>
                </Row>
              </Content>
              {/* 검색필터 끝 */}

              {/* 요약 */}
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor={'none'}
                style={{ marginBottom: 5 }}
              >
                <Row gutter={[5, 5]}>
                  {[
                    {
                      title: '상품수',
                      value: chartData?.product
                        ? Object.keys(chartData?.product).length
                        : 0,
                      unit: '개',
                    },
                    {
                      title: '카테고리수',
                      value: chartData?.category
                        ? Object.keys(chartData?.category).length
                        : 0,
                      unit: '개',
                    },
                    {
                      title: '브랜드수',
                      value: chartData?.shop
                        ? Object.keys(chartData?.shop).length
                        : 0,
                      unit: '개',
                    },
                  ].map((_item, _index) => (
                    <Col x={8} key={`${_item.label}-${_index}`}>
                      {/* <Content width="100%" padding={'20px 25px'}>
                    </Content> */}
                      <div
                        className="boxShadow"
                        style={{
                          background: '#FFFFFF',
                          borderRadius: 4,
                          width: `99.5%`,
                          height: `98%`,
                          margin: '0 auto',
                          padding: '16px 15px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Statistic
                          title={_item.title}
                          value={_item.value}
                          suffix={_item.unit}
                          direction={'row'}
                          style={{ justifyContent: 'center' }}
                        />
                      </div>
                    </Col>
                  ))}
                </Row>
              </Content>
              {/* 요약 끝 */}

              {/* ===== 차트: start ===== */}
              <Row gutter={[5, 5]}>
                {/* === 상품별: start === */}
                <Col x={8}>
                  <Content maxWidth={'100%'} borderRadius={4} padding={0}>
                    <Title
                      size={5}
                      align="center"
                      style={{ padding: '14px 20px' }}
                    >
                      장바구니에 담긴 상위 10개 상품
                    </Title>
                    <Divider style={{ margin: 0 }} />
                    <PieChart
                      width={400}
                      height={300}
                      style={{
                        width: '100%',
                        padding: 10,
                      }}
                    >
                      <Pie
                        // data={data}
                        data={productChart.slice(0, 10)}
                        cx="50%"
                        cy="50%"
                        // paddingAngle={1}
                        // label
                        isAnimationActive={false}
                        // labelLine={false}
                        label={renderCustomLabel}
                        innerRadius={35}
                        outerRadius={90}
                        fill="#8884d8"
                        dataKey="value"
                      >
                        {productChart.slice(0, 10).map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </Content>
                </Col>
                {/* === 상품별: end === */}

                {/* === 카테고리별: start === */}
                <Col x={8}>
                  <Content maxWidth={'100%'} borderRadius={4} padding={0}>
                    <Title
                      size={5}
                      align="center"
                      style={{ padding: '14px 20px' }}
                    >
                      저장된 상품의 상위10개 카테고리
                    </Title>
                    <Divider style={{ margin: 0 }} />
                    <PieChart
                      width={430}
                      height={300}
                      style={{
                        width: '100%',
                        padding: 10,
                      }}
                    >
                      <Pie
                        // data={data}
                        data={categoryChart}
                        cx="50%"
                        cy="50%"
                        isAnimationActive={false}
                        // labelLine={false}
                        label={renderCustomLabel}
                        innerRadius={35}
                        outerRadius={90}
                        fill="#8884d8"
                        labe
                        dataKey="value"
                      >
                        {categoryChart.slice(0, 10).map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </Content>
                </Col>
                {/* === 카테고리별: end === */}

                {/* === 브랜드별: start === */}
                <Col x={8}>
                  <Content maxWidth={'100%'} borderRadius={4} padding={0}>
                    <Title
                      size={5}
                      align="center"
                      style={{ padding: '14px 20px' }}
                    >
                      저장된 상품의 브랜드
                    </Title>
                    <Divider style={{ margin: 0 }} />
                    <PieChart
                      width={430}
                      height={300}
                      style={{
                        width: '100%',
                        padding: 10,
                      }}
                    >
                      <Pie
                        // data={data}
                        data={shopChart}
                        cx="50%"
                        cy="50%"
                        isAnimationActive={false}
                        // labelLine={false}
                        label={renderCustomLabel}
                        innerRadius={35}
                        outerRadius={90}
                        fill="#2814d8"
                        // label
                        dataKey="value"
                      >
                        {shopChart.slice(0, 10).map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </Content>
                </Col>
                {/* === 브랜드별: end === */}
              </Row>
              {/* ===== 차트: end ===== */}

              {/* ===== Raw 데이터: start ===== */}
              <Row gutter={[5, 5]}>
                <Col x={24}>
                  <Content
                    maxWidth={'100%'}
                    padding={20}
                    // backgroundColor={'none'}
                    style={{ margin: '5px 0' }}
                  >
                    <Title size={5} style={{ marginBottom: 10 }}>
                      상품별 순위
                    </Title>
                    {/* {(() => {
                      console.log('productChart: ', productChart);
                    })()} */}
                    <Table
                      bordered
                      size="small"
                      dataSource={
                        productChart
                          .sort((a, b) => a.value - b.value)
                          .reverse() ?? []
                      }
                      columns={[
                        {
                          title: '상품명',
                          dataIndex: 'name',
                        },
                        {
                          title: '업체명',
                          dataIndex: 'shop_information_name',
                          width: 350,
                          align: 'center',
                        },
                        {
                          title: '저장횟수',
                          dataIndex: 'value',
                          width: 170,
                          align: 'center',
                          render: (value) => `${stringToMoneyFormat(value)}개`,
                        },
                        {
                          title: '판매가격',
                          dataIndex: 'price',
                          width: 150,
                          align: 'center',
                          render: (value) => `${stringToMoneyFormat(value)}원`,
                        },
                        {
                          title: '상세',
                          dataIndex: 'price',
                          width: 150,
                          align: 'center',
                          render: (_, record) => (
                            <Button
                              size="small"
                              onClick={() =>
                                setUserListModal(
                                  record.data[0]?.product_id ?? null
                                )
                              }
                            >
                              유저목록 조회
                            </Button>
                          ),
                        },
                      ]}
                    />
                  </Content>
                </Col>
              </Row>
              {/* ===== Raw 데이터: end ===== */}
            </Col>
          </Row>
        </Content>
      </Spin>

      {/* ===== ===== */}
      <ModalLayout
        type="drawer"
        maxWidth={700}
        // isOpen={true}
        open={userListModal !== null}
        title="주문상세내역"
        closable={true}
        onCancel={() => setUserListModal(null)}
        styles={{
          body: { padding: 15 },
        }}
      >
        <Title size={5}>검색된 유저({userList?.length ?? 0})</Title>
        <Table
          // bordered
          style={{ marginTop: 10 }}
          size="small"
          dataSource={userList ?? []}
          scroll={{ x: 660 }}
          columns={[
            {
              title: '고객번호',
              dataIndex: 'user_id',
              width: 85,
              align: 'center',
            },
            {
              title: '고객명',
              dataIndex: 'user_name',
              width: 120,
              align: 'center',
            },
            {
              title: '성별',
              dataIndex: 'user_gender',
              width: 90,
              align: 'center',
            },
            {
              title: '가입플랫폼',
              dataIndex: 'social_type',
              width: 100,
              align: 'center',
            },
            {
              title: '주소',
              dataIndex: 'user_address',
              width: 250,
            },
          ]}
        />
      </ModalLayout>
    </>
  );
};

export default CartAnalyzePresenter;
